/* eslint-disable no-unused-vars */
import classnames from "classnames";
import { ErrorMessage } from "formik";
import { Input } from "antd";
import { MdErrorOutline } from "react-icons/md";
import { FiPlus, FiTrash2 } from "react-icons/fi";

/* eslint-disable react/prop-types */
const DynamicTextInput = ({
  type = "text",
  title,
  name,
  placeholder,
  requiredField = false,
  errors,
  values,
  handleChange,
  handleBlur,
  touched,
  readOnly = false,
  push,
  remove,
  index,
  pushName = "default",
  dynamicFieldMap,
}) => {
  const totalFields = values[pushName]?.length || 1;
  const isLastField = index === totalFields - 1;

  return (
    <div className="mt-5">
      <div className="flex items-center gap-2">
        <Input
          size="small"
          id={name}
          name={name}
          readOnly={readOnly}
          type={type}
          placeholder={placeholder}
          onChange={handleChange}
          onBlur={handleBlur}
          value={values[name]}
          className={classnames(
            "h-[36px] w-full rounded-md border-0 py-[6px] text-gray-500 ring-1 ring-inset placeholder:text-gray-400 placeholder:font-light focus:ring-inset sm:text-sm sm:leading-6",
            errors && errors[name] && touched && touched[name]
              ? "ring-red-600 focus:ring-red-600 text-red-600"
              : "ring-gray-200/10 focus:ring-primary-dark",
            readOnly &&
              "bg-gray-100 hover:bg-gray-100 focus:bg-gray-100 cursor-not-allowed focus:ring-gray-400"
          )}
        />

        {/* Add Button - only on the last field */}
        {isLastField && (
          <button
            type="button"
            onClick={() => push(dynamicFieldMap[pushName] || {})}
            className="p-2 border rounded text-green-600 hover:bg-green-100"
            title="Add below"
          >
            <FiPlus />
          </button>
        )}

        {/* Remove Button - show on all, disable on first if it's the only field */}
        <button
          type="button"
          onClick={() => remove(index)}
          disabled={totalFields === 1}
          className={classnames(
            "p-2 border rounded",
            totalFields === 1
              ? "text-gray-300 cursor-not-allowed border-gray-200"
              : "text-red-600 hover:bg-red-100 border-red-300"
          )}
          title={
            totalFields === 1
              ? "At least one field is required"
              : "Remove this field"
          }
        >
          <FiTrash2 />
        </button>
      </div>

      <ErrorMessage name={name}>
        {(msg) => (
          <div className="text-xs text-red-500 text-left w-full flex gap-1 items-center mt-1">
            <MdErrorOutline size={16} />
            <p className="text-xs">{msg}</p>
          </div>
        )}
      </ErrorMessage>
    </div>
  );
};

export default DynamicTextInput;
